export default "__VITE_ASSET__DPRW0blL__"